import React from 'react';
import './styles.css';
import './styles/ui-select.css';
import './styles/pages/login.css';
import './header/header.css';
import { ToastProvider } from './context/ToastContext.jsx';
import AppContent from './AppContent.jsx';

function App() {
  return (
    <ToastProvider>
      <AppContent />
    </ToastProvider>
  );
}

export default App;
